import EbookCard from "@components/EbookCard";
import ClientLogos from "@components/new-ui/ClientLogos";
import NewLayout from "@components/new-ui/Layout";
import Image from "next/image";
import { useEffect, useState } from "react";
import { MdArrowOutward } from "react-icons/md";

const EbookPillarPage: React.FC = () => {
    const [isMobile, setIsMobile] = useState<boolean>(false);

    const checkMobileView = () => {
        setIsMobile(window.innerWidth <= 768);
    };

    useEffect(() => {
        checkMobileView();
        window.addEventListener("resize", checkMobileView);
        return () => {
            window.removeEventListener("resize", checkMobileView);
        };
    }, []);

    const redirectToFreeTrial = () => {
        window.open("https://app.gallabox.com/signup", "_blank");
    };

    return (
        <NewLayout
            title="Download WhatsApp Business resources | Gallabox growth hacks"
            description="Download our free, curated ebooks and reports to master WhatsApp sales, marketing, support and pretty much anything related to WhatsApp Business automation."
            canonical="https://gallabox.com/resources/downloadables"
            ogAttributes={{ image: "https://assets.gallabox.com/gb-home/ebook/ebook-pillar-og.png" }}
        >
            <section style={{ background: "linear-gradient(104deg, #F0F8FF 39.74%, #C3D3FF 84.28%, #3868FD 102.96%)" }}>
                <div className="flex flex-col max-w-7xl mx-auto pt-36 md:px-10 pb-20">
                    <h1 className="text-3xl md:text-6xl md:pb-10  pb-8 font-bold md:leading-tight text-center md:text-left">
                        The only place to be for growth hacks on WhatsApp Business
                    </h1>
                    <p className="text-xl px-2 text-center md:text-left">
                        Download our free, curated ebooks and reports to master WhatsApp sales, marketing, support and pretty much anything &apos;automation&apos; for your business
                        usecases.
                    </p>
                </div>
            </section>

            <div className="lg:max-w-7xl mx-auto py-16">
                <h3 className="text-base text-center font-normal py-2">Trusted by 10,000+ businesses</h3>
                <ClientLogos />
            </div>

            <EbookCard />

            <section className="max-w-7xl mx-auto  md:px-10  py-24">
                <p className="text-blue-400 text-base font-medium md:px-0 px-4">AWARDS</p>
                <div className="flex flex-col items-center md:flex-row pt-5">
                    <p className="text-4xl md:text-5xl font-semibold max-w-sm md:max-w-lg md:px-0 px-3 pb-6 md:pb-0">Recognized by industry leaders</p>
                    <Image
                        width={610}
                        height={610}
                        src={isMobile ? "https://assets.gallabox.com/gb-home/ebook/award-logo-for-moblie.png" : "https://assets.gallabox.com/gb-home/ebook/award-logo.png"}
                        alt="client-logo-data"
                        className="mx-auto"
                    />
                </div>
            </section>

            <section style={{ background: "linear-gradient(105deg, #A1C7FF 10.23%, #396AFF 21.87%, #00238D 81.07%, #000 98.72%)" }}>
                <div className="flex flex-col max-w-7xl mx-auto md:py-20 md:px-10 py-5 px-5">
                    <p className="text-4xl md:text-6xl md:fond-semibold text-white pb-8">Scale your business outcomes on WhatsApp</p>
                    <p className="text-base text-white pb-6">
                        Gallabox helps you manage your customer lifecycle on WhatsApp, right from &apos;lead qualified&apos; to &apos;deal closed&apos;.
                    </p>
                    <div className="flex gap-8 md:flex-row flex-col items-center">
                        <button className="py-4 px-7 md:w-fit w-full text-base font-bold rounded bg-black  text-white" onClick={redirectToFreeTrial}>
                            <span className="flex items-center justify-center gap-1">
                                Try for free
                                <MdArrowOutward fontSize="25px" />
                            </span>
                        </button>
                    </div>
                </div>
            </section>
        </NewLayout>
    );
};

export default EbookPillarPage;
